<template>
    <div>
        <label v-if="label">{{ label }}</label>
        <CInput
            :label="labelDays"
            :value.sync="extraTimeComponent.days"
            :horizontal="horizontal"
            :placeholder="placeholderDays"
            :size="size"
            type="number"
        >
        </CInput>
        <CInput
            :label="labelMonths"
            :value.sync="extraTimeComponent.months"
            :horizontal="horizontal"
            :placeholder="placeholderMonths"
            :size="size"
            type="number"
        >
        </CInput>
        <CInput
            :label="labelYears"
            :value.sync="extraTimeComponent.years"
            :horizontal="horizontal"
            :placeholder="placeholderYears"
            :size="size"
            type="number"
        >
        </CInput>
    </div>
</template>

<script>
import baseMixin from "~/mixins/base.js";

export default {
    name: "CCInputExtraTime",
    mixins: [baseMixin],
    data() {
        return {
            extraTimeComponent: {
                days: null,
                months: null,
                years: null,
            },
        };
    },
    props: {

        label: {
            type: String,
            default: null,
        },

        labelDays: {
            type: String,
            default: "Days",
        },

        placeholderDays: {
            type: String,
            default: "Days",
        },

        labelMonths: {
            type: String,
            default: "Months",
        },

        placeholderMonths: {
            type: String,
            default: "Months",
        },

        labelYears: {
            type: String,
            default: "Years",
        },

        placeholderYears: {
            type: String,
            default: "Years",
        },

        value: {
            required: true,
        },
        horizontal: {
            type: Boolean,
            default: false,
        },
        size:{
            type: String,
            default: "md"
        }
    },
    watch: {
        value: {
            async handler(newValue) {
                this.extraTimeComponent = newValue;
            },
            deep: true,
        },
        extraTimeComponent: {
            handler(newValue) {

                if(typeof newValue.days === "string"){
                    newValue.days = parseInt(newValue.days);
                }
                if(typeof newValue.months === "string"){
                    newValue.months = parseInt(newValue.months);
                }
                if(typeof newValue.years === "string"){
                    newValue.years = parseInt(newValue.years);
                }

                this.$emit("update:value", newValue);
                this.$emit("change", newValue);
            },
            deep: true,
        },
    },
    methods: {
    },
    async mounted() {
        if (this.value) {
            this.extraTimeComponent = this.value;
        }
    },
};
</script>

<style>
.range__not_defined {
    accent-color: gray;
}
</style>
